import messages from 'containers/SignupPages/AuthByContratEpargnSuccess/messages';
import Header from 'containers/SignupPages/Header';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAuthContratEpargn } from 'store/contract/selectors';
import { ContratEpargnInfo } from 'store/contract/types';
import ActionsButtons from '../ActionsButtons';
import { AUTH_BY_CONTRACT_EPARGN_SMS, PERSONAL_INFO } from '../constants';
import ContractInfo from './ContractInfo';

export type AuthByContractSuccessProps = {
  intl: IntlShape;
  contrat: ContratEpargnInfo;
  setSignupStep: Function;
};
const AuthByContractSuccess = (props: AuthByContractSuccessProps) => {
  return (
    <>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
      />
      <ContractInfo {...props.contrat} />
      <ActionsButtons
        previousLabel={translate({ ...messages.precedent }, props)}
        nextLabel={translate({ ...messages.suivant }, props)}
        onClickNext={() => {
          props.setSignupStep(AUTH_BY_CONTRACT_EPARGN_SMS);
        }}
        onClickPrevious={() => {
          props.setSignupStep(PERSONAL_INFO);
        }}
      />
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  contrat: getAuthContratEpargn,
});

export default connect(mapStateToProps)(injectIntl(AuthByContractSuccess));
